export enum RoleWorkspacePermissionEntity {
  WORKSPACE = 'workspace',
  TEAM = 'team',
  PROJECT = 'project',
  WORKSPACE_MEMBER = 'workspaceMember',
  TEAM_MEMBER = 'teamMember',
  PROJECT_MEMBER = 'projectMember',
  INTEGRATION = 'integration',

  GIT_REPOSITORY = 'gitRepository',
  GIT_REPOSITORY_BRANCH = 'gitRepositoryBranch',
  GIT_REPOSITORY_COMMIT = 'gitRepositoryCommit',
  GIT_REPOSITORY_FILE = 'gitRepositoryFile',

  AI = 'ai',
}
